import React from 'react';
import SinglePrice from './PriceOptions/SinglePrice';
import NoPrice from './PriceOptions/NoPrice';
import SinglePriceWithPriceOnRequest from './PriceOptions/SinglePriceWithPriceOnRequest';
import FullPrice from './PriceOptions/FullPrice';

interface MonthlyPrice {
  name: string;
  currency_code: string;
  price: number;
  duration_metric: string;
}

interface MonthlyPricesProps {
  prices: MonthlyPrice[];
  resources: string[];
  workspaceType: Record<string, boolean>;
}

const MonthlyPrices: React.FC<MonthlyPricesProps> = ({ prices, workspaceType }) => {
  type OfficeType = 'Virtual Office' | 'Private Office' | 'Coworking Space' | 'Airport Lounge';
  const countMappings: Record<string, OfficeType[]> = {
    '0000': ['Private Office', 'Coworking Space', 'Virtual Office', 'Airport Lounge'],
    '0001': ['Airport Lounge', 'Private Office', 'Coworking Space', 'Virtual Office'],
    '0010': ['Virtual Office', 'Private Office', 'Coworking Space', 'Airport Lounge'],
    '0011': ['Virtual Office', 'Airport Lounge', 'Private Office', 'Coworking Space'],
    '0100': ['Coworking Space', 'Private Office', 'Virtual Office', 'Airport Lounge'],
    '0101': ['Coworking Space', 'Airport Lounge', 'Private Office', 'Virtual Office'],
    '0110': ['Coworking Space', 'Virtual Office', 'Private Office', 'Airport Lounge'],
    '0111': ['Coworking Space', 'Virtual Office', 'Airport Lounge', 'Private Office'],
    '1000': ['Private Office', 'Coworking Space', 'Virtual Office', 'Airport Lounge'],
    '1001': ['Private Office', 'Airport Lounge', 'Coworking Space', 'Virtual Office'],
    '1010': ['Private Office', 'Virtual Office', 'Coworking Space', 'Airport Lounge'],
    '1011': ['Private Office', 'Virtual Office', 'Airport Lounge', 'Coworking Space'],
    '1100': ['Private Office', 'Coworking Space', 'Virtual Office', 'Airport Lounge'],
    '1101': ['Private Office', 'Coworking Space', 'Airport Lounge', 'Virtual Office'],
    '1110': ['Private Office', 'Coworking Space', 'Virtual Office', 'Airport Lounge'],
    '1111': ['Private Office', 'Coworking Space', 'Virtual Office', 'Airport Lounge'],
    'default': ['Private Office', 'Coworking Space', 'Virtual Office', 'Airport Lounge'],
  };
  const selectedCounts = [
    workspaceType['privateOfficeCount'],
    workspaceType['deskCount'],
    workspaceType['virtualOfficeCount'],
    workspaceType['loungeCount'],
  ];
  
  const key = selectedCounts.map(count => count ? '1' : '0').join('');
  const names = countMappings[key] || countMappings['default'];

  if (Object.values(workspaceType).filter((state) => state == true).length == 1) {
    return <SinglePrice names={names} prices={prices} />
  } else if (prices.length === 0) {
    return <NoPrice names={names} />
  } else if (prices.length === 1) {
    return <SinglePriceWithPriceOnRequest names={names} prices={prices} />
  } else {
    return <FullPrice names={names} prices={prices} />
  }
};

export default MonthlyPrices;
